import React from 'react';
import { Row, Typography } from '@app/ui';
import { Trans } from 'react-i18next';
import { DefaultFiltersForm } from './DefaultFiltersForm';

export const DefaultFilters = () => {
    return (
        <div className="user-settings-default-filters">
            <Row>
                <Typography.Title
                    style={{
                        fontWeight: 400,
                        fontSize: 16,
                        marginTop: '0.5em',
                        marginBottom: '1.5em',
                    }}
                >
                    <Trans
                        i18nKey="clientConfiguration.defaultFilters.description"
                        ns="settings"
                        components={{ strong: <strong /> }}
                    >
                        <strong>Manage Default Filter</strong> - This impacts
                        what the filters show when you log in.
                    </Trans>
                </Typography.Title>
            </Row>

            <DefaultFiltersForm />
        </div>
    );
};
